import BaseRegulation from '../base_regulation';
import SessionTimerController from "../../../../components/session_timer/session_timer_controller";
import LastLoginComponentController
    from "../../../../components/regulation_components/base/last_login/last_login_component_controller";
import {CLOCK_LOCALIZATION} from "../../../clock/clock_service_consts";
import LastLoginCompositeController
    from "../../../../components/regulation_components/base/last_login/last_login_composite_controller";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";
import { NAVIGATION_VIEWS } from '../../../../components/external_links/external_links_consts';

export default abstract class USBaseRegulation extends BaseRegulation {

    static CLASS = 'USBaseRegulation';

    /**
     * The time after which the Last Login is replaced with the Session Timer in UI
     */
    protected _switchToSessionTimerWaitInterval = null;


    protected abstract _getRegulationType(): number;

    init(params) {
        super.init(params);
        this._switchToSessionTimerWaitInterval = (params.switchToSessionTimerWaitInterval && params.switchToSessionTimerWaitInterval[this._getRegulationType()]) || 60000;
    }

    shouldHaveBetLimitsPerBrand(): boolean {
        return true;
    }

    onKickEvent(kickParams) {
        Event.fire(SYSTEM_EVENTS.GEO_KICK_EVENT, kickParams);
    }

    getLastLoginComponent(params) {
        let lastLoginComponent = LastLoginComponentController.create(params);
        let sessionTimerComponent = SessionTimerController.create();
        return LastLoginCompositeController.create({lastLoginComponent: lastLoginComponent, sessionTimerComponent: sessionTimerComponent, switchToSessionTimerWaitInterval: this._switchToSessionTimerWaitInterval});
    }

    hybridNyxClosedButtonEnabled(){
        return true;
    }


    sessionTimerVisible() {
        return true;
    }

    sessionTimerEnabled() {
        return true;
    }

    supportWithdrawOnlyFromReal() {
        return false;
    }

    getClockLocalization() {
        return CLOCK_LOCALIZATION.SERVER;
    }

    getExternalLinksConfig() {
        return {
            'sport': {
                view: {
                    hybrid: NAVIGATION_VIEWS.SECOND_WEB_VIEW
                }
            }
        };
    }

    private _getDetailedMessagesList(messages: string[]): string {
        return messages.join('\n\n');
    }
}
